import { message } from 'antd';
import * as ACTIONS from 'app/actions/TrainingActions';

const initialState = {
    isLoadingNames: false,
    listNames: [],

    isLoadingSubdirection: false,
    listSubdirections: [],

    isLoadListTraining: false,
    listTraining: [],
    
    filter: {
        listNames: [],
        listSubdirections: []
    },

    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },

    isLoadExport: false, 
    isSaveRecord: false,

    isLoadEmployee: false,
    listEmployee: [],
    listEmployeeId: [],

    isSaveEmployee: false,

    trainingSelect: [],
    isLoadTrainingSelect: false
}

export const TrainingReducer = (state = initialState, action) => {
    switch(action.type) {
        //Obtiene el combo nombres
        case ACTIONS.GET_NAMES_REQUEST:
            return {
                ...state,
                isLoadingNames: true
            }
        case ACTIONS.GET_NAMES_SUCCESS:
            return {
                ...state,
                isLoadingNames: false,
                listNames: action.payload
            }
        case ACTIONS.GET_NAMES_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingNames: false
            }

        //Obtiene el combo de las subdirecciones
        case ACTIONS.GET_SUBDIRECTION_REQUEST:
            return {
                ...state,
                isLoadingSubdirection: true
            }
        case ACTIONS.GET_SUBDIRECTION_SUCCESS:
            return {
                ...state,
                isLoadingSubdirection: false,
                listSubdirections: action.payload
            }
        case ACTIONS.GET_SUBDIRECTION_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingSubdirection: false
            }

        //Obtiene los tipos de capacitación
        case ACTIONS.FETCH_TRAINING_REQUEST:
            return {
                ...state,
                isLoadListTraining: true
            }
        case ACTIONS.FETCH_TRAINING_SUCCESS:
            return {
                ...state,
                isLoadListTraining: false,
                listTraining: action.payload,
                pagination: {...state.pagination, total: action.payload.length > 0 ? action.payload[0].totalCount : 0 }
            }
        case ACTIONS.FETCH_TRAINING_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadListTraining: false
            }

        //Guarda los filtros
        case ACTIONS.SAVE_FILTER:
            return {
                ...state,
                filter: action.payload
            }

        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }
        
        //Exporta los datos
        case ACTIONS.EXPORT_TRAINING_REQUEST:
            return {
                ...state,
                isLoadExport: true
            }
        case ACTIONS.EXPORT_TRAINING_SUCCESS:
            return {
                ...state,
                isLoadExport: false
            }
        case ACTIONS.EXPORT_TRAINING_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadExport: false
            }

        //Inserta o actualiza el registro
        case ACTIONS.INSUPD_TRAINING_REQUEST:
            return {
                ...state,
                isSaveRecord: true
            }
        case ACTIONS.INSUPD_TRAINING_SUCCESS:
            message.success(action.payload);
            return {
                ...state,
                isSaveRecord: false
            }
        case ACTIONS.INSUPD_TRAINING_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isSaveRecord: false
            }

        //Obtiene los empleados administradores
        case ACTIONS.GET_EMPLOYEE_ADMIN_REQUEST:
            return {
                ...state,
                isLoadEmployee: true
            }
        case ACTIONS.GET_EMPLOYEE_ADMIN_SUCCESS:
            return {
                ...state,
                isLoadEmployee: false,
                listEmployee: action.payload
            }
        case ACTIONS.GET_EMPLOYEE_ADMIN_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadEmployee: false
            }
        
        //Obtiene los ids empleados administradores
        case ACTIONS.GET_EMPLOYEE_ADMIN_ID_REQUEST:
            return {
                ...state,
                isLoadEmployee: true
            }
        case ACTIONS.GET_EMPLOYEE_ADMIN_ID_SUCCESS:
            return {
                ...state,
                isLoadEmployee: false,
                listEmployeeId: action.payload
            }
        case ACTIONS.GET_EMPLOYEE_ADMIN_ID_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadEmployee: false
            }

        case ACTIONS.SAVE_ADMIN:
            return {
                ...state,
                listEmployeeId: action.payload
            }

        //Guarda los empleados
        case ACTIONS.SAVE_ADMIN_REQUEST:
            return {
                ...state,
                isSaveEmployee: true
            }
        case ACTIONS.SAVE_ADMIN_SUCCESS:
            message.success("Administradores actualizados correctamente");
            return {
                ...state,
                isSaveEmployee: false
            }
        case ACTIONS.SAVE_ADMIN_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isSaveEmployee: false
            }

        //Obtiene los componentes select
        case ACTIONS.GET_TRAINING_EMPLOYEE_REQUEST:
            return {
                ...state,
                isLoadTrainingSelect: true
            }
        case ACTIONS.GET_TRAINING_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isLoadTrainingSelect: false,
                trainingSelect: action.payload
            }
        case ACTIONS.GET_TRAINING_EMPLOYEE_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadTrainingSelect: false
            }

        //Limpia el reducer
        case ACTIONS.CLEAR_REDUCER:
            return initialState;

        default:
            return state; 
    }
}